import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const PaymentSuccessPage = () => {
  const location = useLocation();
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paid, setPaid] = useState(false);

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get('session_id');
    if (sessionId) {
      api.get(`/payments/checkout-session/${sessionId}`)
        .then(res => {
          setSession(res.data);
          setPaid(res.data.payment_status === 'paid');
          setLoading(false);
        })
        .catch(err => {
          setError('Nie udało się pobrać informacji o sesji.');
          setLoading(false);
        });
    }
  }, [location]);

  if (loading) return <div className="text-center py-10">Weryfikowanie płatności...</div>;
  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="container mx-auto px-4 py-8 text-center">
      {paid ? (
        <>
          <h1 className="text-4xl font-bold text-green-400 mb-4">Płatność zakończona sukcesem!</h1>
          <p className="text-lg text-gray-300">Dziękujemy za zakup.<br/></p>
          <p className="text-red-400 mb-6">
            Uwaga! Aby odebrać zakupiony produkt, prosimy o kontakt z właścicielem sklepu poprzez Discord lub inną podaną metodę komunikacji, która została podana w opisie sklepu.<br/>
          </p>
        </>
      ) : (
        <h1 className="text-4xl font-bold text-red-400 mb-4">
          Płatność nie została zakończona!
        </h1>
      )}

      {session && (
        <div className="bg-gray-800 rounded-lg shadow-lg p-6 mt-6 max-w-md mx-auto cursor-pointer">
          <p><strong>ID Płatności:</strong> {session.id}</p>
          <p>
            <strong>Kwota:</strong>{' '}
            {(session.amount_total / 100).toFixed(2)}{' '}
            {session.currency.toUpperCase()}
          </p>

          {session.metadata && (
            <>
              <hr className="border-gray-700 my-3" />
              <p><strong>Produkt:</strong> {session.metadata.productName}</p>
              <p><strong>ID produktu:</strong> {session.metadata.productId}</p>
              <p><strong>Cena produktu:</strong> {session.metadata.price} PLN</p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PaymentSuccessPage;